<template>
  <div class="c-page u-relative">
    <section data-color="clear" class="u-relative  u-fit-w u-bg--brand-dark u-overflow-h js-header-panel">
      <div class="c-page__header o-wrapper--panel" :style="'transform:translateX(' + headerPageSize[2] + 'px) translateY('+headerPageSize[3]+'px) scale('+headerPageSize[4]+')'" >
           <!--<img src="/static/HeadImages/Marine_Holdings-Vessels-1800x900.jpg" class="u-absolute u-pos-tl" :style="'width:' + headerPageSize[0] + 'px; height:'+headerPageSize[1]+'px' ">-->
           <svg id="#Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="1020 -720 3000 2000">
          <radialGradient id="a" cx="2775.218" cy="852.018" r="1496.996" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#8c8d8e"/>
            <stop offset=".442" stop-color="#e0e2df"/>
            <stop offset="1" stop-color="#a4a5a7"/>
          </radialGradient>
          <path opacity=".05" fill="url(#a)" d="M1099.3-42.9c54.9 10.8 110.3 22.9 168.9 35.6 193.3 42.1 393.2 85.7 589.8 85.7 119.6 0 224.3-16.1 320.1-49.3 102.7-35.5 215.6-104.4 335.2-177.3 196.8-120 400.3-244.1 592.3-244.1 108.1 0 200.9 39.5 283.6 120.9 61.5 60.5 102.2 118.3 141.6 174.2 66.5 94.4 129.3 183.5 280.1 263.4 84.1 44.6 163.4 66.3 242.3 66.3 2.9 0 5.8 0 8.7-.1l11.6-.2-4-10.9c-10.3-27.5-21.4-55.3-33.2-82.6l-2.1-4.9-5.3-.1c-70.2-1.4-140.2-17.4-208-47.4-148.5-65.8-211.9-158-278.9-255.5-41-59.7-83.4-121.4-147.3-180.9-83.9-78.2-176.1-116.2-281.9-116.2-189 0-384 122.2-572.6 240.3-117 73.3-227.5 142.5-329.2 177.6-93.3 32.2-195.9 47.9-313.5 47.9-195.9 0-396.4-43.4-590.3-85.4-61.7-13.4-120.1-26-177.6-37.1-46.9-9-93.8-18.3-140.6-27.7l-5.4-1.1-3.1 4.5c-12.9 19-25.8 39-39.4 61l-6.2 10 11.5 2.4c50.9 10.6 101.9 21 152.9 31z"/>
          <radialGradient id="b" cx="2781.999" cy="650.838" r="1471.638" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#8c8d8e"/>
            <stop offset=".442" stop-color="#e0e2df"/>
            <stop offset="1" stop-color="#a4a5a7"/>
          </radialGradient>
          <path opacity=".05" fill="url(#b)" d="M1833.7 510.7c2.3-1.7 310.6-199 478.6-199 60.7 0 121.9 11.5 181.9 34.3 141 53.4 236.8 159.9 338.3 272.7 107.3 119.2 218.3 242.5 386.4 294.6 77.9 24.2 161.4 36.4 248.2 36.4 200.7 0 424.7-62.8 704.9-197.7l4.9-2.4-.3-5.5c-1.3-25.8-3.3-52.8-5.9-80.3l-1.2-12.2-10.8 5.7C3960 761.7 3728.4 873 3493.5 873c-73.6 0-144.8-11.3-211.7-33.5-157.8-52.5-259.7-170.9-358.2-285.4-89.2-103.6-181.4-210.8-314.3-268-67.3-29-137-43.7-207.2-43.7-115.3 0-226.3 38.6-334.3 96 193.9-120.7 392-228.3 587.3-228.3 87.8 0 167.9 21.4 244.8 65.4 49.9 28.6 91.4 64.4 127 101.4l.1-.1s70.9 77.8 147.6 76.4l162.9-2.9c.4 0 59.3-.1 72.8-65.7l41.1-164.2c8.7-31.2-4.7-57-10.5-66.3-32.8-48.3-72.9-100.8-129.5-148.4-86.8-73-184.1-108.4-297.5-108.4-224.9 0-473.4 145.4-692.7 273.7-137.3 80.3-267 156.2-379.4 191.6-91.7 28.9-188.3 43-295.2 43-202.5 0-407.5-51.3-605.7-101-42.5-10.6-84.7-21.2-126.6-31.2-29.7-7.1-59.3-14.4-89-21.6l-6.8-1.7-2.7 6.5C804 184.7 792.7 214.1 782 244l-3 8.5 26.4 6.8c12.2 3.2 24.5 6.3 36.8 9.4 36 9.1 72.1 18.5 108.4 28 200 52.3 406.9 106.3 612.9 106.3 105.6 0 201.8-13.9 294.2-42.4 118.7-36.7 254-116.1 397.3-200.2 222.3-130.4 474.2-278.3 700.1-278.3 106.7 0 199 31.7 282.2 96.9 25.9 20.3 49.7 43.2 73.2 69.7 7.5 9.7 31.5 43.2 27.4 67.5l-16.6 99.9c-5.5 32.9-33.2 34.7-41.9 34.5l-2.7-.2-95.6-5.6c-6.5-.5-28.4-4.2-52-31.8l-.1.1c-38.6-41.7-76.9-74.3-118.4-100.4-82.1-51.6-169.2-76.7-266.4-76.7-235.1 0-476.3 148.6-709.4 292.4-150.8 92.9-293.2 180.7-422.3 220-88.2 26.8-178.7 39.9-276.7 39.9-204.5 0-409.8-59-609-116.2l-8.5-2.5-1.8 8.7c-5.7 27.7-10.8 56.3-15.2 84.8l-1.1 7.1 6.9 2c175.2 51.4 362 101.5 548.8 101.5 97.9 0 188.7-13.2 277.5-40.5 89.7-27.1 299.7-122.1 300.3-122.5z"/>
          <radialGradient id="c" cx="2775.218" cy="852.018" r="1496.996" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#8c8d8e"/>
            <stop offset=".442" stop-color="#e0e2df"/>
            <stop offset="1" stop-color="#a4a5a7"/>
          </radialGradient>
          <path opacity=".3" fill="url(#c)" d="M3759.4 380.8c-56.2-24.3-103.6-54.9-146-94.5-44.1-34.3-60.9-3-66.9 17.3-2.3 7.9-3.1 14.3-3.1 14.3l-20.6 95.1-2.2 10c-4.6 17.1-18.2 50.5-54.6 56l-112.6 17-.3-.3-32.7 4.9c-17.7 3-95.8 20.8-24.1 95 52.2 47.4 105.7 81.2 166.7 105.3 69.6 27.5 142.9 41.4 218 41.4 141.2 0 288.1-45.6 476.3-147.9l5-2.7-.8-5.6c-1.2-8.8-2.5-17.6-3.8-26.4l-1.8-11.4-10.2 5.4c-149.9 79.6-275.2 116.7-394.3 116.7-72.3 0-143.4-14.3-211.3-42.7-22.6-9.4-44.1-20.3-64.8-32.6-20-12.8 1.2-19.2 1.2-19.2l78.2-11.3s3.8 0 9.4-1.4c13.4-3.3 37.3-14.5 44.8-53.9l12.5-65.6c1.1-4.8 5.6-16.5 24.5-5l.1-.5c19 11 38.6 21.3 59.7 30.2 70.2 29.7 144.2 44.8 219.7 44.8 67.6 0 136.4-11.4 210.1-35l7.1-2.3-1.5-7.3c-4-18.7-8.2-37.3-12.8-55.8l-2-8-8 2c-126.8 31.6-246 22.8-358.9-26z"/>
        </svg>
    </div>
    <div class="o-wrapper--valign u-viewport-fit-h u-fit-w">
          <div class="u-relative u-inline-block u-valign-middle u-marg-t-vh1of40 u-fit-w u-pad-l-w3of12   u-pad-l-w2of12@xl u-pad-r-w4of12 u-pad-r-w3of12@xl u-pad-x-w1of12@sm">
            <h1 class="t-h2-main-title-marine-holdings c-page__subtitle t-text--base-bold  t-text-lh--md u-color--white u-marg-b-xl" v-html="contentSuperYachts.title"> </h1>
            <div class="introduction__inner">
              <div class="introduction__borderLeft scroll">
                  <div  class="scroll">
                       <span  class="background"></span>
                       <span  class="triangle"></span>
                       <span  class="label"> <!--<app-push-button :visible="isButtonVisible" :isIntro="!0" :active="isButtonActive" :to="{ name: '/'}" :text="uiexplore" >{{uiexplore}}</app-push-button>-->Scroll to discover</span>

                  </div>
              </div>
                <div class="introduction__titles">
                   <div class="introduction__titlesInner">
                        <div class="introduction__subtitle">
                          <h1 class="t-h3 t-text--roman t-text-lh--md u-color--white">
                              <!-- <app-animated-text :text="contentNavalVessel.smalldescriptioon" :active="!0" ></app-animated-text>-->
                              <app-sliced-text :content="contentSuperYachts.smalldescriptioon"></app-sliced-text>
                          </h1>
                      </div>
                  </div>
              </div>
            </div>

            </div>
            <app-home-slide  inline-template  data-color="clear" class="c-home__section  u-flex  u-flex-jc--center u-fit-w u-overflow-h "       :content="contentprod"       :headerPageSize="headerPageSize"   :activeIndex="activeIndex"   :navOffsetTop="navOffsetTop"     :indexSS="0"   :hasVideo="!1"  >
                   <div class="u-fit-w" >
                      <div class="c-home__section__fade u-relative u-zindex--3 u-flex u-flex-fd--column@md u-w9of12 u-w9of12@md u-fit-w@sm u-pad-x-w1of12@sm u-pad-x-w0of0@sm">
                                 <div class="c-team__content  u-marg-t-xs@lg u-marg-t-xs@sm u-w2of2 u-w3of4@xsm u-marg-x-w1of12@sm u-w9of10@md  u-w9of10lg u-marg-t-lg@sm" >
                                     <section class="u-relative js-header-panel" data-color="clear">
                                       <div class="c-team__section-container u-relative u-pad-r-w1of12 u-pad-y-xxl@md u-pad-y-lg@sm u-pad-x-w0of0@sm">
                                           <div class="c-team__section u-marg-t-lg u-marg-t-xl@lg u-marg-t-xs@sm">
                                                 <div class="u-flex u-flex-fw--wrap  u-flex-jc--space-between">
                                                         <router-link class="c-team__link c-subsidiries__link t-link  u-marg-r-sub--wmax@xl u-marg-r-sub--wmin@sm u-marg-r-cov--wmax@lg u-marg-r-sub--wmaxp@fullHD u-marg-top-min--subsi@xsm" :class="{'u-opacity--15 u-hide-min@xs':index==1}"  :to="item.websiteurl"   v-for="(item, index)  in content.product_sections[0].PRODUCTS"  :data-index="index" :key="index"  @mouseenter="onHoverPopin((item.first_name + item.last_name).replace(/\s/g,''),index)" @mouseleave="onHoverOutPopin((item.first_name+item.last_name).replace(/\s/g,''),index)" >
                                                          <div class="c-team__link__photo-container js-photo-container u-relative o-box--6by10 u-marg-b-md u-overflow-h u-force-3d is-loading" >
                                                                  <div class="u-absolute u-pos-t u-zindex--2"></div>
                                                                  <img class="c-team__link__photo__hover u-zindex--1 o-wrapper--panel u-fit u-object-fit-cover u-backface-hidden fade-leave-to" :id="('hover'+item.first_name + item.last_name).replace(/\s/g,'')"  :src="item.image.sizes.medium_large"       @load="_onLoadMemberImage(index)"></img>
                                                                  <img class="c-team__link__photo u-zindex--1 o-wrapper--panel u-fit u-object-fit-cover u-backface-hidden" :id="(item.first_name + item.last_name).replace(/\s/g,'')"  :src="item.image.sizes.medium"       @load="_onLoadMemberImage(index)"></img>
                                                          </div>
                                                          <div class="u-pad-r-sm"></div>
                                                      </router-link>
                                                 </div>
                                           </div>
                                       </div>
                                     </section>
                                 </div>
                           </div>
                         </div>
              </app-home-slide>
      </div>

  </section>
<div class="c-page">
 <section  data-color="dark" class="u-relative   js-header-panel" style="background:rgba(255,255,255,1)">
<div class="l-container--wide">
   <ul class="u-marg-a-0 u-pad-a-0">
           <li class="p-top__yacht__menu__item u-pad-y-lg" v-if="areTherePosts"  v-for="(post,index)  in contentSuperYachts[1]"  :data-index="index"    :id="(post.title).replace(/\s/g,'')"  @click="onOpenPopin(post,index)"  @mouseenter="onHoverPopin((post.title).replace(/\s/g,''),index)" @mouseleave="onHoverOutPopin((post.title).replace(/\s/g,''),index)">
               <div class="u-marg-a-0 u-pad-a-0">
                   <a class="p-top__yacht__banner c-yacht--bg  js-hover  parallax-x"  title="View Images" :class="{'left':((index+1)%2!=0)}"    href="javascript:void(0);" >
                        <div class="c-yacht--bg__cover js-target--parallax">
                          <vue-load-image>
                          <div slot="image" class="c-yacht--bg__img supperyachtlarge" :data-src="post.images[0].sizes.large"   :style="{'background-image':'url('+post.images[0].sizes.large+')' }"></div>
                            <img slot="preloader" src="/static/HeadImages/image-loader.gif" />
                            <div slot="error">error message</div>
                          </vue-load-image>
                            <!--  <div class="c-yacht--bg__img supperyachtlarge" :style="{'background-image':'url('+post.images[0].sizes.large+')' }"></div>
                        <div class="c-yacht--bg__img supperyachtlargemedium" :style="{'background-image':'url('+post.images[0].sizes.medium_large+')' }"></div>
                           <div class="c-yacht--bg__img supperyachtmob" :style="{'background-image':'url('+post.images[0].sizes.large+')' }"></div>-->
                           <h3 class="p-top__yacht__banner__title c-yacht--bg__title" :style="'left:'+post.postitle+'vw'">
                             <strong class="fonts__b--regular js-target--wayPoint wayPointTitle split-target w-not-check--lang is-show"  v-html="post.title"></strong>
                          </h3>
                          </div>
                         <div class="js-hover__bg p-hover__bg" style="width: 1500px; height: 1500px;"></div>
                     </a>
                       <div class="p-top__yacht__panel u-color--gray" :class="{'leftpaddingremover':((index+1)%2==0)}" :style="'left:'+post.pannelPos+'vw'">
                             <h3 class="p-top__yacht__panel__title" v-html="post.title" ></h3>
                             <!--<p style="background-image:url('/static/Yacht/DownthetitleYacht.png');background-position: left bottom, left top;height:100px;background-repeat:no-repeat;"></p>-->
                             <p class="c-description js-target--wayPoint fade is-show u-color--gray" v-html="post.first_paragraph_shorted"></p>
                             <!--<button  class="c-footer__btn-submit t-btn t-btn--primary-ms t-text--xs u-relative u-color--white  u-w1of2-1" @click="onOpenPopinPHOTOS(post,index)"  ><span>more specs</span></button>
                             <button  class="c-footer__btn-submit t-btn t-btn--primary-ms t-text--xs u-relative u-color--white  u-w1of2-1" @click="onOpenPopin(post,index)"  ><span>more photos</span></button>-->
                       </div>
                       <div class="u-fit-w@sm p-top__yacht__panel-maincharacteristics" :class="{'leftpaddingremover':((index+1)%2==0)}" style="background-color: rgba(226,228,227,0);">
                             <tabs>
                                   <tab :name="post.ItemListspecsTitleA" :selected="true" >
                                     <ul class="o-list u-fit  ultransformproductmarine dispDeskonly" >
                                       <li v-for="(itemList, indexlist)  in post.ItemListspecsA"  class="u-relative u-flex u-fit-w  u-overflow-h t-text--sm  boeder-right-marine-product" >
                                             <div class="u-w8of10 t-text-lh--xl u-color--brand-blue u-align-center" style="margin: 0 auto;" v-html="itemList.label"></div>
                                             <div class=" u-absolute  u-pos-bl u-fit-w u-bg--gray-light"></div>
                                       </li>
                                      </ul>
                                      <ul class="o-list u-fit  ultransformproductmarine dispMobileonly" >
                                        <li v-for="(itemList, indexlist)  in post.ItemListspecsM"  class="u-relative u-flex u-fit-w  u-overflow-h t-text--sm  boeder-right-marine-product" >
                                              <div class="u-w8of10 t-text-lh--xl u-color--brand-blue " style="margin: 0 auto;" v-html="itemList.label"></div>
                                              <div class=" u-absolute  u-pos-bl u-fit-w u-bg--gray-light"></div>
                                        </li>
                                       </ul>
                                   </tab>

                                   <!--<tab :name="post.ItemListspecsTitleB">
                                       <ul class="o-list u-fit  ultransformproductmarine" >
                                         <li v-for="(itemList, indexlist2)  in post.ItemListspecsB"   class="u-relative u-flex u-fit-w  u-overflow-h t-text--sm boeder-right-marine-product" >
                                               <div class="u-w8of10 t-text-lh--xl u-color--brand-blue u-w1of2" style="margin: 0 auto;"  v-html="itemList.label"></div>
                                               <div class=" u-absolute  u-pos-bl u-fit-w u-bg--gray-light"></div>
                                         </li>
                                     </ul>
                                   </tab>-->
                           </tabs>
                     </div>
                </div>
                  <div class=" u-absolute u-pos-bl u-fit-w u-bg--gray-light"></div>
            </li>
        </ul>
  </div>
</section>
</div>
<app-footer :globalContent="globalContent" :adminContent="adminContent"></app-footer>
<app-ship-details   :content="popinContent" :key="componentKey" :title="popinTitle" :index="0"  :isActive="isPopinActive"  ></app-ship-details>
<app-ship-photos   :content="popinContent"  :title="popinTitle" :index="0"  :isActive="isPopinActivePhotos"  ></app-ship-photos>
</div>
</template>
<script>
import {format, compareAsc} from 'date-fns'
import AppFooter from  '../app-footer/index.vue'
import  AppSlicedText from '../app-sliced-text/index.vue'
import   CoreAjaxForm from     '../core-ajax-form/index.vue'
import AppTeamBoardPopin from '../app-team-board-popin/index.vue'
import AppShipDetailsPopin from '../app-ship-details/index.vue'
import AppShipDetailsPhotos from '../app-ship-photos/index.vue'
import {getAbsoluteBoundingRect}  from '../../utilities/getAbsoluteBoundingRect.js'
import AppScrollObject from '../app-scroll-object/index.vue'
import VueLoadImage from 'vue-load-image'
import tabs from  '../app-tabs/index.vue'
import tab from '../app-tab/index.vue'
import appHomeSlide from '../app-home-slide/index.vue'
export default
{
          components:{

                                    "app-sliced-text":AppSlicedText,
                                    "app-footer":AppFooter,
                                    'core-ajax-form':CoreAjaxForm,
                                    'app-ship-details':AppShipDetailsPopin,
                                    'app-ship-photos':AppShipDetailsPhotos,
                                    "app-scroll-object":AppScrollObject,
                                    "tabs":tabs,
                                    "tab":tab,
                                     AppTeamBoardPopin,
                                    'app-home-slide':appHomeSlide,
                                      'vue-load-image': VueLoadImage,

                    },
                  props: {
                      adminContent: {
                          type: Object,
                          default: function() {}
                      },
                      globalContent: {
                          type: Object,
                          default: function() {}
                      },
                      headerPageSize: {
                          type: Array,
                          default: function() {}
                      }
                  },
                  data: function() {
                      return {
                          areTherePosts: !1,
                          areThereCategories: !1,
                          selectedOption:'',
                          CarModel:Object(),
                           popinContent: null,
                           popinTitle: null,
                            isPopinActive: !1,
                            isPopinActivePhotos: !1,
                            isButtonClicked:false,
                            isButtonVisible: !0,
                            isButtonActive: !1,
                            uiexplore:"Scroll to discover",
                            componentKey: 0,
                            activeIndex: 0,
                            activeRollOverIndex: 0,
                            navHeight: 0,
                            navOffsetTop: 0
                      }
                  },
                  computed:
                  {
                    contentprod: function() {
                        return this.adminContent.en.pages.products
                    },
                    contentSuperYachts: function()
                     {
                         return  this.adminContent.en.superyachts
                     },

                        computedPostsCategories: function()
                        {
                          var t = [];

                              if (Object.keys(this.adminContent.en.superyachts).length > 0)
                              {
                                  if (this.adminContent.en.superyachts.categories)
                                  {
                                      this.areThereCategories = !0;
                                      var   n = this.adminContent.en.superyachts.categories.length;
                                      for (var e = 0;e < n; e += 1)
                                      {
                                          var r =  this.adminContent.en.superyachts.categories[e];
                                           t.push(r)
                                      }

                                  }
                                  else
                                  {
                                   this.areThereCategories = !1,
                                   t.push({
                                      title: "Error - Page not found",
                                      first_paragraph_shorted: "Incorrect page number. <br /> Please click on one of the page numbers below.",
                                      dateFormated: {
                                          day: 404,
                                          month: "",
                                          year: ""
                                      }
                                  })
                                }
                              }


                          return t
                        }
                        ,
                      computedPosts: function()
                      {
                          var t = [];
                            this.areTherePosts = !0;
                            var   n = this.adminContent.en.superyachts[1].length;
                            for (var e = 0;e < n; e += 1)
                                {
                                          var r = this.adminContent.en.superyachts[1][e];
                                        /*  r.dateFormated = {
                                              day: format(r.post_wp.post_date, "DD"),
                                              month: format(r.post_wp.post_date, "MMMM"),
                                              year: format(r.post_wp.post_date, "YY")
                                          },*/
                                           t.push(r)
                                  }
                                this.popinContent =   t[0]
                              return t
                      },
                      computedPages: function()
                      {
                          var t = [];
                          if (this.$route.query.page) {
                              t.length = 0;
                              for (var e = 0, n = Object.keys(this.adminContent.en.superyachts).length; e < n; e += 1) {
                                  var r = Object.keys(this.adminContent.en.superyachts)[e];
                                  t.push({
                                      index: parseInt(r, 10),
                                      isVisible: !0
                                  })
                              }
                          }
                          return t
                      },
                      computedCurrentPageIndex: function()
                      {
                          var t = 1;
                          return t = this.adminContent.en.superyachts[1]
                      }
                  },
                  beforeCreate: function()
                  {
                      //this.$route.query.page || this.$router.push("/theelitecars/current-stock?page=1")
                  },
                  created: function()
                  {
                      //this.adminContent.en.pages.blog.blog_is_active ? this.$route.query.page || this.$router.replace("/theelitecars/current-stock?page=1") : this.$router.replace("/404"),
                      this.onResize = this.onResize.bind(this),
                      this.posts = this.computedPosts,
                      this.pages = this.computedPages,
                      this.pagecategories =this.computedPostsCategories,
                      this.currentPageIndex = this.computedCurrentPageIndex,
                      this.eventHub.$on("close:popin", this.onClosePopin),
                      this.eventHub.$on("resize", this.onResize)
                  },
                  destroyed: function()
                  {
                      this.eventHub.$off("close:popin", this.onClosePopin),
                      this.eventHub.$off("resize", this.onResize)
                  },
                  mounted: function()
                  {
                    setTimeout(function() {this.isButtonVisible = !0}, 120),
                    setTimeout(function() {this.isButtonActive = !0}, 3e3),
                      this.eventHub.$emit("page:ready"),
                      this.onResize()
                  },

                  methods:
                  {
                    forceRerender() {
                    this.componentKey += 1;
                    },
                    GetCarBrandCateg()
                    {

                        this.CarModel= this.content[this.selectedOption]
                    },
                      onResize: function() {},
                      onOpenPopin: function (t, e)
                      {
                          this.forceRerender();
                          if(this.isButtonClicked)
                             return false;
                          console.log("popin");
                          var n = this;
                          this.popinIndex = 0,
                          this.popinContent =  t,
                          this.popinTitle =   t.title,
                          this.eventHub.$emit("disable:scroll"),
                          this.eventHub.$emit("open:popin"),
                          setTimeout(function ()
                          {
                              n.isPopinActive = !0,
                              n.$el.classList.add("is-popin-active"),
                              n.onTransition()
                          }, 50)
                      },
                      onOpenPopinPHOTOS: function (t, e)
                      {
                          this.forceRerender();
                          this.isButtonClicked=true;
                          //alert("popin photo");
                          var n = this;
                          this.popinIndex = 0,
                          this.popinContent =   t,
                          this.popinTitle =   t.title,
                          this.eventHub.$emit("disable:scroll"),
                            this.eventHub.$emit("open:popin"),
                          //this.eventHub.$emit("open:popinphotos"),
                          setTimeout(function ()
                          {
                              n.isButtonClicked=false;
                              n.isPopinActivePhotos = !0,
                              //n.$el.classList.add("is-popin-active--photos"),
                              n.$el.classList.add("is-popin-active"),
                              n.onTransition()
                          }, 50)
                      },
                      onHoverPopin: function (t, e)
                      {

                             var n = this;

                              n.$el.querySelector('#'+t).classList.remove("is-start-switching--cars--back"),
                              n.$el.querySelector('#'+t).classList.add("is-start-switching--cars")

                      },
                      onHoverOutPopin: function (t, e)
                      {
                         var n = this;
                           n.$el.querySelector('#'+t).classList.remove("is-start-switching--cars"),
                          n.$el.querySelector('#'+t).classList.add("is-start-switching--cars--back")

                      },
                      onClosePopin: function ()
                      {
                          this.eventHub.$emit("enable:scroll"),

                          this.isPopinActive = !1,
                          this.isPopinActivePhotos = !1,
                          //this.isBoardActive = !1,
                          this.$el.classList.remove("is-popin-active"),
                          this.onTransition()

                      },
                      onTransition: function ()
                      {
                          var t = this;
                          this.$el.classList.add("is-switching"),
                          clearTimeout(this._timerTransition),
                          this._timerTransition = setTimeout(function () {
                              t.$el.classList.remove("is-switching")
                          }, 650)
                      }
                  }
    }

</script>
<style  scoped>
.l-container--wide
{
    width: 87.5vw;
    margin-right: auto;
    margin-left: auto;
}
.p-top__yacht__menu__item:nth-of-type(odd)
{
    margin-left: -6.25vw;

}
.p-top__yacht__menu__item
{
    width: 107.142857%;
    border-bottom: 1px solid hsla(224,74%, 13%, 1);
}

.c-yacht--bg {
    position: relative;
    overflow: hidden;
}

.p-top__yacht__banner {
    display: block;
    width: 100%;
    height: 37.5vw;
}



.c-yacht--bg.left .c-yacht--bg__cover {
    -webkit-transform-origin: right;
    transform-origin: right;
}

.c-yacht--bg__cover {
    top: 50%;
    left: 50%;
    -webkit-transform: translate3d(-50%,-50%,1px) scale(1);
    transform: translate3d(-50%,-50%,1px) scale(1);
    -webkit-transform-origin: left;
    transform-origin: left;
    line-height: 1;
    font-size: 0;
    letter-spacing: 0;
}

.c-yacht--bg.parallax-x .c-yacht--bg__img {
    width: calc(100% + 30px);
    left: 0;
}

.c-yacht--bg.left .c-yacht--bg__img {
    right: 0;
    left: auto;
}
.c-yacht--bg__cover, .c-yacht--bg__img {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
}
.c-yacht--bg__img {
    top: 0;
    left: 0;
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
}


.p-top__yacht__menu__item:nth-of-type(odd)
.p-top__yacht__banner__title {
    left: 12.5vw;
}
/*
.p-top__yacht__menu__item:nth-of-type(2n) {
    margin-left: 0;
}

.p-top__yacht__menu__item:nth-of-type(2n) .p-top__yacht__banner__title {
    left: 56.25vw;
}
.p-top__yacht__menu__item:nth-of-type(2n) .p-top__yacht__panel {
    margin-left: auto;
}*/
.p-top__yacht__banner__title {
    position: absolute;
    top: 10vw;
    color: #fff;
    line-height: 1;
    /*z-index: 1;*/
}

.p-top__yacht__banner__title>strong {
    display: block;
    font-size: 3.4375vw;
    letter-spacing: .1em;
    margin-bottom: 5px;
}

.fonts__b--regular {
  font-family: 'Aquawax-Pro-Medium';
}


.p-top__yacht__panel {
    position: relative;
    width: 43.75vw;
    padding: 20px 6.25vw 20px;
    /*  margin-top: -11.25vw;*/
    background-color: #ffffff;
    /*z-index: 1;*/
    opacity: 0.9
}


.js-target--wayPoint.fade.is-show {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
}
.js-target--wayPoint.fade {
    opacity: 0;
    -webkit-transform: scale(1.08);
    transform: scale(1.08);
    -webkit-transform-origin: top;
    transform-origin: top;
    -webkit-transition: opacity 1.2s linear,-webkit-transform 1.2s cubic-bezier(0,.6,.2,1);
    transition: opacity 1.2s linear,-webkit-transform 1.2s cubic-bezier(0,.6,.2,1);
    transition: opacity 1.2s linear,transform 1.2s cubic-bezier(0,.6,.2,1);
    transition: opacity 1.2s linear,transform 1.2s cubic-bezier(0,.6,.2,1),-webkit-transform 1.2s cubic-bezier(0,.6,.2,1);
}
.c-description {
    font-size: 1.1rem;
    line-height: 1.2;
}

  .p-hover__bg {
    position: absolute;
    top: 0;
    left: 0;
    background-color: #1a1a1a;
    opacity: 0;
    -webkit-transform: translate3d(-50%,-100%,0) rotate(20deg) scaleY(1.8);
    transform: translate3d(-50%,-100%,0) rotate(20deg) scaleY(1.8);
    -webkit-transition: none;
    transition: none;
  /*  z-index: 1;*/
}

.c-yacht--bg.left .p-hover__bg {
    -webkit-transform: translate3d(50%,-100%,0) rotate(-20deg) scaleY(1.8);
    transform: translate3d(50%,-100%,0) rotate(-20deg) scaleY(1.8);
}
.p-top__yacht__panel__title{
    line-height: 1;
    margin-bottom: 30px;

}





.p-top__yacht__menu__item {
	width: 107.142857%
}

.p-top__yacht__menu__item:nth-of-type(odd) {
	margin-left: -6.25vw
}

.p-top__yacht__menu__item:nth-of-type(odd) .p-top__yacht__banner__title {
	left: 12.5vw
}
/*
.p-top__yacht__menu__item:nth-of-type(2n) {
	margin-left: 0
}

.p-top__yacht__menu__item:nth-of-type(2n) .p-top__yacht__banner__title {
	left: 56.25vw
}

.p-top__yacht__menu__item:nth-of-type(2n) .p-top__yacht__panel {
	margin-left: auto
}
*/
.p-top__yacht__banner {
	display: block;
	width: 100%;
	height: 37.5vw
}

.p-top__yacht__banner__title {
	position: absolute;
	top: 10vw;
	color: #fff;
	line-height: 1;
	/*z-index: 1*/
}

.p-top__yacht__banner__title>small {
	display: block;
	margin-bottom: 15px;
	font-weight: 600
}

.p-top__yacht__banner__title>strong
{
	display: block;
	font-size: 3.4375vw;
	letter-spacing: .1em;
	margin-bottom: 5px
}

.p-top__yacht__banner__title>span
{
	display: block;
	font-size: 1.5vw;
	letter-spacing: .1em
}

.p-top__yacht__panel
{
	position: relative;
	width: 43.75vw;
	padding: 20px 6.25vw 20px;
	/*margin-top: -11.25vw;*/
	background-color: #ffffff;
	/*z-index: 1*/
}

.p-top__yacht__panel-maincharacteristics
{
	position: relative;
	padding: 20px 6.25vw 20px;
  padding-right: 0px;
	background-color: #ffffff;
	/*z-index: 1*/
}


.p-top__yacht__panel__title
{
	line-height: 1;
	margin-bottom: 30px
}

.p-top__yacht__panel__title>small {
	display: inline-block;
	margin-right: 20px;
	padding-top: 5px;
	font-weight: 600;
	vertical-align: top
}

.p-top__yacht__panel__title>span {
	display: inline-block;
	font-size: 3rem;
	font-weight: 700;
	letter-spacing: .1em;
	vertical-align: top
}

.p-top__yacht__panel__btn {
	margin-top: 20px
}

@media screen and (min-width: 1600px)
{
  .p-top__yacht__banner__title>strong {
		font-size: 2.5rem
	}
	.p-top__yacht__banner__title>span {
		font-size: 2.4rem
	}
	.p-top__yacht__panel {
		margin-top: 0px
	}
}

@media screen and (max-width: 770px)
{
.p-top__yacht__menu__item {
    width: 100vw;
}
/*.p-top__yacht__banner {
    height: 66.66667vw;
}*/
.p-top__yacht__banner {
    height: 40.66667vw;
}
.c-yacht--bg {
    position: relative;
}
.p-top__yacht__panel {
    width: 87.5vw;
    /*margin-top: -13.333vw;*/
    margin-top: 0vw;
    padding-top: 30px;
    padding-bottom: 35px;
}
.p-top__yacht__panel__title {
    margin-bottom: 15px;
}
.p-top__yacht__panel__title>small {
    margin-right: 10px;
    font-size: 1rem;
}
.p-top__yacht__panel__title>span {
    font-size: 2.5rem;
}
.c-description {
    font-size: 0.85rem;
    line-height: 1.4;
}
/*
.p-top__yacht__menu__item:nth-of-type(2n) {
    margin-left: -6.25vw;
}
*/
}
.dispMobileonly
{
  display: none;
}
.dispDeskonly
{
  display: flex;
}
@media screen and (max-width: 770px)
{
   .p-top__yacht__banner__title
   {
     display: none;
   }

}
@media screen and (max-width: 550px)
{
   .p-top__yacht__banner__title{
     display: none;
   }
   .dispMobileonly
   {
     display: block;
   }
   .dispDeskonly
   {
     display: none;
   }
}

.leftpaddingremover
{
  padding-left: 0px;
}
</style>
